import Button from "../components/Button";

const ConfirmModal = ({ title, message, onConfirm, onCancel }) => {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div className="bg-white rounded p-6 w-96 space-y-4">
				<h3 className="text-lg font-semibold">{title}</h3>
				<p>{message}</p>
				<div className="flex justify-end gap-2">
					<Button label="Cancel" onClick={onCancel} variant="secondary" />
					<Button label="Confirm" onClick={onConfirm} variant="danger" />
				</div>
			</div>
		</div>
	);
};

export default ConfirmModal;